// export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const phoneRegExp = /[1-9]{1}[0-9]{9}/;
const plotNoRegExp = /^\d+((\/)\d+)?$/;
const pincodeRegExp = /^[1-9][0-9]{5}$/;
const referralCodeCharLimit = 9;
const referralCodeRegExp = /^[a-z]{6}\d{3}$/gi;
// regexp errors when doesn't match
const companyNameCharLimit = 50;
const companyNameCharMin = 3;
const companyNameRegExpMsg = `Please enter valid company name`;
const aadharNoRegExp = /^([2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4})$/;
const gstNoRegExp = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
const panNoRegExp = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
// export const LorryNumRegExp = /^[A-Za-z]{2}\d{2}[A-Za-z]{1,3}(?!0{4})[0-9]{4}$/gi;
// export const LorryNumRegExp = /^[a-z]{2}[a-z0-9]*$/gi;
const LorryNumRegExp = /^[a-zA-Z]{2}(?=.*\d)[a-zA-Z0-9]*$/;
const GstNumberRegexExpNew = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[A-Za-z0-9]{1}Z[A-Za-z0-9]{1}$/;

export { GstNumberRegexExpNew, LorryNumRegExp, aadharNoRegExp, companyNameCharLimit, companyNameCharMin, companyNameRegExpMsg, gstNoRegExp, panNoRegExp, phoneRegExp, pincodeRegExp, plotNoRegExp, referralCodeCharLimit, referralCodeRegExp };
//# sourceMappingURL=regex.js.map
